import { Activity, ClipboardCheck, ListChecks, type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export type CalibracionSeccion = 'codigos' | 'reporte' | 'detalles';

interface Enlace {
  seccion: CalibracionSeccion;
  to: string;
  label: string;
  icon: LucideIcon;
}

const ENLACES: readonly Enlace[] = [
  { seccion: 'codigos', to: '/monitoreo/calibracion', label: 'Códigos', icon: ListChecks },
  { seccion: 'reporte', to: '/monitoreo/calibracion/reporte', label: 'Reporte', icon: Activity },
  {
    seccion: 'detalles',
    to: '/monitoreo/calibracion/reporte/detalles',
    label: 'Detalles',
    icon: ClipboardCheck,
  },
];

const BASE =
  'inline-flex shrink-0 items-center gap-2 rounded-control px-3 py-2 text-xs font-semibold transition-colors';
const INACTIVO = 'border border-ink-200 bg-white text-ink-700 hover:border-brand-300 hover:text-brand-700';
const ACTIVO = 'bg-ink-900 text-white';

/** Submenú del módulo de Calibración. */
export function CalibracionNav({
  active,
  className,
}: {
  active: CalibracionSeccion;
  className?: string;
}) {
  return (
    <nav
      className={cn('flex items-center gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:pb-0', className)}
      aria-label="Secciones de calibración"
    >
      {ENLACES.map((enlace) => (
        <Link
          key={enlace.seccion}
          to={enlace.to}
          aria-current={enlace.seccion === active ? 'page' : undefined}
          className={cn(BASE, enlace.seccion === active ? ACTIVO : INACTIVO)}
        >
          <enlace.icon className="size-3.5" aria-hidden="true" />
          {enlace.label}
        </Link>
      ))}
    </nav>
  );
}
